import { render, staticRenderFns } from "./InvoiceShow.vue?vue&type=template&id=261f8ab0&scoped=true&"
import script from "./InvoiceShow.vue?vue&type=script&lang=js&"
export * from "./InvoiceShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../home/makeeva/projects/mbelab/html/lk.mbelab.com/vue-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261f8ab0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../home/makeeva/projects/mbelab/html/lk.mbelab.com/vue-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VDialog,VRow})
